module.exports = __webpack_public_path__ + "static/media/awfext32_6053.03eaa42a.ico";